<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
    <app-lista-titulo-desc [elements]="elements" [templateNome]="template.name" [cols]="4"></app-lista-titulo-desc>
    <app-lista-titulo-desc [elements]="elementsObs" [templateNome]="template.name" [cols]="12"></app-lista-titulo-desc>
    <app-lista-img [elements]="elements"></app-lista-img>
</app-card-relatorio-laudo>